import format from 'string-format';
import tuneInRequest from '../../tuneInRequest';
export function reports(config, apiContext) {
    const pageViewEndPoint = format('{reports}/reports/v/', config.domains);
    const adReportingEndpoint = format('{reports}/reports/a/', config.domains);
    function sendPageView(params) {
        return tuneInRequest({
            method: 'post',
            url: pageViewEndPoint,
            params: params,
            disableRetry: true,
        }, apiContext);
    }
    function sendAdReport(endpoint, params) {
        return tuneInRequest({
            method: 'post',
            url: `${adReportingEndpoint}${endpoint}`,
            params: params,
        }, apiContext);
    }
    return {
        sendPageView: sendPageView,
        sendAdReport,
    };
}
